import { render, staticRenderFns } from "./RespondView.vue?vue&type=template&id=b3c091aa&"
import script from "./RespondView.vue?vue&type=script&lang=js&"
export * from "./RespondView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports